import { useTranslation } from "react-i18next";
import { approved, logo, coat } from "../../assets/svgs";
import { Link, NavLink } from "react-router-dom";
import { getCurrentYear } from "../../utils/helpers";
import { isEmptyArray } from "../../utils/checkers";
import { useTanstack } from "../../hooks/useTanstack";
import styles from "./footer.module.scss";

export const Footer = () => {
  const { t } = useTranslation();
  const { data } = useTanstack("getWebItems");

  return (
    <footer className={styles.footer}>
      <div className={styles.footer_top}>
        <div className="container">
          <ul className={styles.footer_top_list}>
            {data?.map(({ id, name, dropdown, sub_dropdowns, path }) => {
              return (
                <li key={id} className={styles.footer_top_title}>
                  {isEmptyArray(dropdown) ? (
                    <Link to={path}>
                      <p>{name}</p>
                    </Link>
                  ) : (
                    <>
                      <p>{name}</p>

                      <div className={styles.footer_top_context}>
                        <ul>
                          {dropdown?.map(({ id, name, path }) => {
                            return (
                              <li key={id}>
                                <NavLink
                                  to={path}
                                  className={({ isActive }) =>
                                    isActive
                                      ? styles.active
                                      : styles.footer_top_link
                                  }
                                >
                                  {name}
                                </NavLink>
                              </li>
                            );
                          })}
                        </ul>

                        {sub_dropdowns && (
                          <ul>
                            {sub_dropdowns?.map(({ id, items }) => {
                              return (
                                <div key={id}>
                                  <ul>
                                    {items?.map(({ id, name, path }) => (
                                      <li key={id}>
                                        <NavLink
                                          to={path}
                                          className={({ isActive }) =>
                                            isActive
                                              ? styles.active
                                              : styles.footer_top_link
                                          }
                                        >
                                          {name}
                                        </NavLink>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              );
                            })}
                          </ul>
                        )}
                      </div>
                    </>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className={styles.footer_bottom}>
        <div className="container">
          <div className={styles.footer_bottom_main}>
            <div className={styles.footer_bottom_right}>
              <div className={styles.footer_bottom_right_approved}>
                {approved.icon}
                <p>{t("approved_text")}</p>
              </div>
              <div className={styles.footer_bottom_right_links}>
                <Link to="personal" className={styles.footer_bottom_right_link}>
                  {t("personal_title")}
                </Link>
                <Link
                  to="availability"
                  className={styles.footer_bottom_right_link}
                >
                  {t("availability_title")}
                </Link>
              </div>
              <p>
                © {getCurrentYear()} {t("webname")}
              </p>
            </div>

            <div className={styles.footer_bottom_right_icons}>
              <div className={styles.footer_bottom_right_coats}>
                {logo.icon}
              </div>
              <div className={styles.footer_bottom_right_coats}>
                {coat.icon}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
